import ExpandMoreIcon from '@trustoo/components/ui/icon/ExpandMoreIcon'
import clsx from 'clsx'
import { useState } from 'react'
import { SIGNAL_ICON_CLASSES, SIGNAL_ICON_LABEL } from './healthScoreConstants'
import type { HealthScoreSignal } from './types'

interface SignalRowProps {
    signal: HealthScoreSignal
}

const SignalRow = ({ signal }: SignalRowProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const hasDetail = Boolean(signal.stat || signal.substat)

    return (
        <div className="border-b border-neutral-100 last:border-b-0 py-2">
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                aria-expanded={isOpen}
                className="flex items-center gap-3 w-full text-left">
                <span
                    aria-hidden
                    className={clsx(
                        'flex-shrink-0 w-6 h-6 rounded-full inline-flex items-center justify-center text-sm font-bold',
                        SIGNAL_ICON_CLASSES[signal.severity],
                    )}>
                    {SIGNAL_ICON_LABEL[signal.severity]}
                </span>
                <span className="flex-1 text-md text-neutral-900">{signal.text}</span>
                {hasDetail && (
                    <ExpandMoreIcon
                        size={20}
                        className={clsx(
                            'flex-shrink-0 text-neutral-400 transition-transform duration-150',
                            isOpen && 'rotate-180',
                        )}
                    />
                )}
            </button>
            {isOpen && hasDetail && (
                <div className="pl-9 pr-2 pt-2 pb-1 space-y-0.5">
                    {signal.stat && (
                        <p className="text-md font-medium text-neutral-800">{signal.stat}</p>
                    )}
                    {signal.substat && (
                        <p className="text-sm italic text-neutral-500">{signal.substat}</p>
                    )}
                </div>
            )}
        </div>
    )
}

export default SignalRow
